import React, { useEffect, useState, useRef } from "react";
import Accordion from "../../component/global/accordion";
import Drawer from "../../component/global/drawer";
import ViewConfig from "../../config/viewConfig";
import ModalContent from "../../component/global/modal";
import CardCarousel from "../../component/global/cardCarousel";
import { addData, baseUrl, loadData } from "../../config/data";
import AutoResizeTextArea from "../../component/layout/text_area";
import { useDrawerTransition } from "../../context/drawerProvider";
import '../../index.css'
import JobDrawer from "../../component/global/jobDrawer";
import { useDispatch, useSelector } from "react-redux";
import Lang from "../../config/lang";
import CircleEffect from "../../component/global/circleEffect";
import { Link, useParams, useSearchParams } from "react-router-dom";
import { setLanguage } from "../../redux/actions/language";
import Input from "../../component/global/input";
import Select from 'react-select';
import Swal from "sweetalert2";

const Raising = () => {
    const dispatch = useDispatch();
    const { lang } = useSelector((state) => state.globalReducer);
    const { language } = useParams();
    const [searchParams] = useSearchParams();

    const [isDrawerOpen, setIsDrawerOpen] = useState(false);
    const [drawerTitle, setDrawerTitle] = useState('Menu');

    const [isOpenDrawer, setIsOpenDrawer] = useState(false);
    const [selectedEventName, setSelectedEventName] = useState('');
    const [registrationForm, setRegistrationForm] = useState({
        fullName: '',
        phoneNumber: '',
        email: '',
        schoolName: '',
        lastEducation: '',
        yearGraduated: 0,
        major: '',
        jobID: 0,
        lastExperience: '',
        eventID: 0
    })
    const [partnershipForm, setPartnershipForm] = useState({
        schoolName: '',
        picName: '',
        picPhoneNumber: '',
        picEmail: '',
        address: '',
        eventID: 0
    })
    const [formType, setFormType] = useState('school') // [school, jobfair, partnership]
    const [formTitle, setFormTitle] = useState('Pre-Registration') // [Pre-Registration, Register, Start Your Journey with SOPRA Early]
    const [formDescription, setFormDescription] = useState('Thank you for your interest in joining SOPRA Group. This form is the first step in registering your interest to become part of SOPRA Group. Once you submit your information, our Human Capital Management team will review your details and contact you for the next steps in the recruitment process.');
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [submitErrorMessage, setSubmitErrorMessage] = useState('');
    const [isSubmitSuccess, setIsSubmitSuccess] = useState(false);
    const [isShareModalOpen, setIsShareModalOpen] = useState(false);
    const [isShareLinkCopied, setIsShareLinkCopied] = useState(false);
    const [shareModalType, setShareModalType] = useState('link'); // [link, qr]
    const [shareModalData, setShareModalData] = useState({
        shareUrl: '',
        qrImage: '',
        emailUrl: '',
        whatsappUrl: '',
        facebookUrl: '',
        linkedinUrl: '',
        eventName: '',
    });

    const { fullName, phoneNumber, email, schoolName: registrationSchoolName, lastEducation, yearGraduated, major, jobID, lastExperience } = registrationForm;
    const { schoolName: partnershipSchoolName, picName, picPhoneNumber, picEmail, address } = partnershipForm;

    const [blogData, setBlogData] = useState([]);
    const [ongoingEventData, setOngoingEventData] = useState([]);
    const [upcomingEventData, setUpcomingEventData] = useState([]);
    const [jobData, setJobData] = useState([]);
    const [institutionData] = useState([
        {
            name: "Universitas Negeri Malang",
            image: "/asset/raising_star/institution/unm.png"
        },
        {
            name: "Universitas Telkom",
            image: "/asset/raising_star/institution/telkom.png"
        },
        {
            name: "Universitas Gadjah Mada",
            image: "/asset/raising_star/institution/ugm.png"
        },
        {
            name: "Institut Sains & Teknologi Terpadu",
            image: "/asset/raising_star/institution/istts.png"
        },
        {
            name: "Universitas Katolik Widya Mandala",
            image: "/asset/raising_star/institution/ukwm.png"
        },
        {
            name: "Politeknik Negeri Jamber",
            image: "/asset/raising_star/institution/politeknik.png"
        },
        {
            name: "SMK Yapanes Gempol",
            image: "/asset/raising_star/institution/yapanes.png"
        },
        {
            name: "SMKN 1 Bangil",
            image: "/asset/raising_star/institution/smkn_1_bangil.png"
        },
        {
            name: "SMKN 1 Gempol",
            image: "/asset/raising_star/institution/smkn_1_gempol.png"
        },
        {
            name: "SMKN 2 Pasuruan",
            image: "/asset/raising_star/institution/smkn_2_pasuruan.png"
        },
        {
            name: "SMKN 2 Surabaya",
            image: "/asset/raising_star/institution/smkn_2_surabaya.png"
        },
        {
            name: "SMKN 6 Malang",
            image: "/asset/raising_star/institution/smkn_6_malang.png"
        },
        {
            name: "SMKN 8 Malang",
            image: "/asset/raising_star/institution/smkn_8_malang.png"
        },
        {
            name: "SMKN Prigen",
            image: "/asset/raising_star/institution/smkn_prigen.png"
        },
        {
            name: "Universitas Brawijaya",
            image: "/asset/raising_star/institution/ub.png"
        },
        {
            name: "Universitas Airlangga",
            image: "/asset/raising_star/institution/unair.png"
        },
        {
            name: "Universitas Surabaya",
            image: "/asset/raising_star/institution/ubaya.png"
        },
        {
            name: "Universitas Negeri Surabaya",
            image: "/asset/raising_star/institution/unesa.png"
        },
        {
            name: "SMKN 3 Kota Bekasi",
            image: "/asset/raising_star/institution/smkn_3_bekasi.png"
        },
        {
            name: "Politeknik Negeri Bandung",
            image: "/asset/raising_star/institution/politeknik_negeri_bandung.png"
        },
        {
            name: "SMKN Teratai Putih Global 4 Bekasi",
            image: "/asset/raising_star/institution/smk_teratai_4_bekasi.png"
        },
        {
            name: "SMK Karya Bahana Mandiri 2",
            image: "/asset/raising_star/institution/kbm_2.png"
        },
        {
            name: "SMKN 1 Kota Bekasi",
            image: "/asset/raising_star/institution/smkn_1_bekasi.png"
        },
        {
            name: "SMKN 4 Kota Bekasi",
            image: "/asset/raising_star/institution/smkn_4_bekasi.png"
        },
    ]);
    const [goalData] = useState([
        {
            name: "goals1_title",
            description: "goals1_description",
            image: "/asset/raising_star/goals/card_1.png"
        },
        {
            name: "goals2_title",
            description: "goals2_description",
            image: "/asset/raising_star/goals/card_2.png"
        }
    ])
    const [highlightData] = useState([
        {
            name: "Career Talk",
            description: "highlights2_description",
            image: "/asset/raising_star/highlight/card_1.png"
        },
        {
            name: "Exclusive Job Fair",
            description: "highlights1_description",
            image: "/asset/raising_star/highlight/card_2.png"
        }
    ])

    const highlightContentRefs = useRef([]);
    const [highlightCardHeight, setHighlightCardHeight] = useState(340);
    
    const [testimonialData] = useState([
        {
            name: "Al Mujtabah - Produksi Trass - SMKN 1 Sukorejo",
            description: "Saya sangat bersyukur dapat mengikuti kegiatan STAR di BKK SMKN 1 Sukorejo. Proses rekrutmen berjalan profesional, jelas, dan transparan sehingga membuat peserta merasa nyaman serta lebih memahami dunia kerja. Semoga kerja sama ini terus berlanjut sehingga semakin banyak lulusan mendapat kesempatan berkarier serta berkembang melalui pembinaan dan pelatihan yang berkualitas."
        },
        {
            name: "Bayu Agung Cahyadi - Junior Operator Produksi - SMKN 1 Sukorejo",
            description: "Pengalaman pertama saya melamar kerja di SOPRA Group melalui jalur STAR menjadi salah satu pengalaman terbaik saya tahun ini. Dari awal acara sudah seru serta proses yang jelas dan mudah diikuti membuat saya lebih percaya diri untuk masuk ke dunia kerja. Tim HC juga ramah dan memperlakukan semua peserta dengan sama, tanpa membedakan pengalaman. Semoga SOPRA GROUP bisa terus membantu lebih banyak anak muda mendapatkan peluang kerja yang baik."
        },
        {
            name: "Amelia Nur Mufidah - Produksi Trass - SMKN 1 Gempol",
            description: "Saat PT Trass Anugerah Makmur datang ke sekolah kami di SMKN 1 Gempol, berkat acara tersebut saya mendapatkan banyak teman untuk saling menyemangati dalam mencari pekerjaan. Acaranya juga banyak pelajaran dan bimbingan, interviewnya juga enjoy karena bapak/ibunya seru, banyak doorprize juga yang buat saya dan teman-teman semangat menjawab pertanyaan dari bapak/ibu. Semoga PT Trass Anugerah Makmur lebih banyak lagi kerjasama dengan sekolah-sekolah."
        }
    ]);
    
    const getCardW = () => typeof window !== 'undefined' && window.innerWidth >= 768 ? 640 : window.innerWidth * 0.82;
    const GAP = 24;
    const CARD_VARIANTS = {
        center: { opacity: 1, scale: 1 },
        side: { opacity: 0.45, scale: 0.9 },
        far: { opacity: 0.15, scale: 0.7 },
    };

    const trackRef = useRef(null);
    const submitFeedbackRef = useRef(null);
    const eventSectionRef = useRef(null);
    const eventRefs = useRef({});
    const handledEventParamRef = useRef(false);
    const isAnimating = useRef(false);
    const tLen = testimonialData.length;
    const [testimonialIndex, setTestimonialIndex] = useState(0);
    const tIdx = (offset) => (testimonialIndex + offset + tLen) % tLen;

    const [lengthBlogData, setlengthBlogData] = useState(0);
    const [lengthEventData, setLengthEventData] = useState(0);
    const [lengthJobData, setLengthJobData] = useState(0);
    const [isEventDataLoaded, setIsEventDataLoaded] = useState(false);

    const getEventId = (event) => Number(event?.eventID || event?.id || 0);

    const encodeEventID = (eventID) => {
        try {
            return btoa(String(eventID));
        } catch {
            return '';
        }
    };

    const decodeEventID = (encodedEventID) => {
        try {
            const decodedValue = Number(atob(encodedEventID));
            return Number.isFinite(decodedValue) && decodedValue > 0 ? decodedValue : null;
        } catch {
            return null;
        }
    };

    const buildEventShareUrl = (eventID) => {
        const encodedEventID = encodeEventID(eventID);
        return `${window.location.origin}/${lang}/raising?eventID=${encodeURIComponent(encodedEventID)}`;
    };

    const showEventUnavailableAlert = () => {
        Swal.fire({
            icon: 'error',
            title: 'Event unavailable',
            text: 'Event is not found or already expired.',
            timer: 2000,
            showConfirmButton: false,
        });
    };

    const scrollToEventTarget = () => {
        const targetElement = eventSectionRef.current;
        if (!targetElement) return;

        const topPosition = targetElement.getBoundingClientRect().top + window.scrollY - 24;
        window.scrollTo({
            top: Math.max(topPosition, 0),
            behavior: 'smooth',
        });
    };

    const openEventRegistration = (eventData, isOngoing = true) => {
        setFormType(eventData.type === 'Job Fair' ? 'jobfair' : 'school');
        setFormTitle(isOngoing ? 'Register' : 'Pre-Register');
        setFormDescription('Thank you for your interest in joining SOPRA Group. This form is the first step in registering your interest to become part of SOPRA Group. Once you submit your information, our Human Capital Management team will review your details and contact you for the next steps in the recruitment process.');
        setSelectedEventName(eventData?.name || '');
        handleResetSubmitState();
        setRegistrationForm((prev) => ({
            ...prev,
            eventID: getEventId(eventData),
        }));
        setIsOpenDrawer(true);
    };

    const openShareModal = (eventData, modalType = 'link') => {
        const eventID = getEventId(eventData);
        if (!eventID) return;

        const shareUrl = buildEventShareUrl(eventID);
        const encodedShareUrl = encodeURIComponent(shareUrl);
        const qrImage = `https://quickchart.io/qr?text=${encodedShareUrl}`;
        const facebookUrl = `https://www.facebook.com/sharer.php?u=${encodedShareUrl}`;
        const whatsappUrl = `https://wa.me/send?text=${encodedShareUrl}`;
        const emailUrl = `mailto:?subject=${encodeURIComponent(`SOPRA Event - ${eventData?.name || 'Event'}`)}&body=${encodedShareUrl}`;
        const linkedinUrl = `https://www.linkedin.com/sharing/share-offsite/?url=${encodedShareUrl}`;
        setShareModalData({
            shareUrl,
            qrImage,
            emailUrl,
            whatsappUrl,
            facebookUrl,
            linkedinUrl,
            eventName: eventData?.name || '',
        });
        setShareModalType(modalType);
        setIsShareLinkCopied(false);
        setIsShareModalOpen(true);
    };

    const handleCopyShareLink = async () => {
        try {
            await navigator.clipboard.writeText(shareModalData.shareUrl || '');
            setIsShareLinkCopied(true);
            setTimeout(() => {
                setIsShareLinkCopied(false);
            }, 1200);
        } catch {
            setIsShareLinkCopied(false);
        }
    };

    const getVariant = (offset) => {
        if (offset === 0) return 'center';
        if (Math.abs(offset) === 1) return 'side';
        return 'far';
    };

    const getBaseOffset = () => {
        const vw = window.innerWidth;
        const sideCount = vw >= 1280 ? 2 : 1;
        return (vw / 2) - (getCardW() / 2) - sideCount * (getCardW() + GAP);
    };

    useEffect(() => {
        const handleResize = () => {
            if (trackRef.current) {
                trackRef.current.style.transition = 'none';
                trackRef.current.style.transform = `translateX(${getBaseOffset()}px)`;
            }
        };
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, [testimonialIndex]);

    useEffect(() => {
        if (!trackRef.current) return;
        trackRef.current.style.transition = 'none';
        trackRef.current.style.transform = `translateX(${getBaseOffset()}px)`;
    }, [testimonialIndex]);

    const navigate = (dir) => {
        if (isAnimating.current || !trackRef.current) return;
        isAnimating.current = true;

        const track = trackRef.current;
        const slideAmount = (getCardW() + GAP) * dir;
        const baseOffset = getBaseOffset();

        const cards = track.querySelectorAll('[data-card-inner]');
        cards.forEach(card => {
            const currentOffset = parseInt(card.getAttribute('data-offset'));
            const nextOffset = currentOffset - dir;
            const nextVariant = getVariant(nextOffset);
            const { opacity, scale } = CARD_VARIANTS[nextVariant];

            card.style.transition = 'opacity 0.45s cubic-bezier(0.4,0,0.2,1), transform 0.45s cubic-bezier(0.4,0,0.2,1)';
            card.style.opacity = opacity;
            card.style.transform = `scale(${scale})`;
        });

        track.style.transition = 'none';
        track.style.transform = `translateX(${baseOffset}px)`;
        track.getBoundingClientRect();
        track.style.transition = 'transform 0.45s cubic-bezier(0.4,0,0.2,1)';
        track.style.transform = `translateX(${baseOffset - slideAmount}px)`;

        setTimeout(() => {
            setTestimonialIndex((prev) => (prev + dir + tLen) % tLen);
            isAnimating.current = false;
            const newCards = track.querySelectorAll('[data-card-inner]');
            newCards.forEach(card => {
                card.style.transition = 'none';
                card.style.opacity = '';
                card.style.transform = '';
            });
        }, 450);
    };

    useEffect(() => {
        if (language) {
            dispatch(setLanguage(language));
        }
    }, [language])

    const loadBlogData = async () => {
        loadData({
            url: `Blogs`,
            params: [{ title: 'limit', value: 3 }, { title: 'page', value: 0 }, { title: 'filter', value: 'status:Published' }],
        }).then(async res => {
            if (res?.data) {
                setBlogData(res.data);
                setlengthBlogData(res?.total);
            }
        })
    };

    const loadEventData = async () => {
        loadData({
            url: `Events`
        }).then(async res => {
            if (res?.data) {
                const today = new Date(); today.setHours(0, 0, 0, 0);
                const ongoing = res.data
                    .filter(event => { const s = new Date(event.startDate); s.setHours(0,0,0,0); const e = new Date(event.endDate); e.setHours(0,0,0,0); return s <= today && e >= today; })
                    .sort((a, b) => new Date(a.startDate) - new Date(b.startDate));
                    
                const upcoming = res.data
                    .filter(event => { const s = new Date(event.startDate); s.setHours(0,0,0,0); return s > today; })
                    .sort((a, b) => new Date(a.startDate) - new Date(b.startDate));

                setOngoingEventData(ongoing);
                setUpcomingEventData(upcoming);
                setLengthEventData(res?.total);
            }
            setIsEventDataLoaded(true);
        }).catch(() => {
            setIsEventDataLoaded(true);
        })
    }

    const loadJob = async () => {
        const now = new Date();
        const formattedDate = now.toISOString().split("T")[0].slice(0, 10);

        loadData({
            url: `Jobs`,
            params: [{ title: 'date', value: formattedDate }]
        }).then(async (res) => {
            if (res?.data) {
                setJobData(res.data);
                setLengthJobData(res?.total);
            }
        })
    }

    useEffect(() => {
        loadBlogData();
        loadEventData();
        loadJob();
    }, [])

    useEffect(() => {
        const updateHighlightCardHeight = () => {
            const measuredHeights = highlightContentRefs.current
                .map((element) => element?.scrollHeight || 0)
                .filter((height) => height > 0);

            const minHeight = window.innerWidth >= 768 ? 340 : 320;

            if (!measuredHeights.length) {
                setHighlightCardHeight(minHeight);
                return;
            }

            const tallestContent = Math.max(...measuredHeights);
            setHighlightCardHeight(Math.max(minHeight, tallestContent));
        };

        const frameId = window.requestAnimationFrame(updateHighlightCardHeight);
        window.addEventListener('resize', updateHighlightCardHeight);

        return () => {
            window.cancelAnimationFrame(frameId);
            window.removeEventListener('resize', updateHighlightCardHeight);
        };
    }, [lang, highlightData]);

    useEffect(() => {
        if (!isEventDataLoaded || handledEventParamRef.current) return;

        const encryptedEventID = searchParams.get('eventID');
        if (!encryptedEventID) {
            handledEventParamRef.current = true;
            return;
        }

        handledEventParamRef.current = true;
        const decodedEventID = decodeEventID(encryptedEventID);

        const allEvents = [
            ...ongoingEventData.map((event) => ({ ...event, isOngoing: true })),
            ...upcomingEventData.map((event) => ({ ...event, isOngoing: false })),
        ];

        if (!decodedEventID) {
            scrollToEventTarget();
            showEventUnavailableAlert();
            return;
        }

        const selectedEvent = allEvents.find((event) => getEventId(event) === decodedEventID);

        if (!selectedEvent) {
            scrollToEventTarget();
            showEventUnavailableAlert();
            return;
        }

        scrollToEventTarget();
        setTimeout(() => {
            openEventRegistration(selectedEvent, selectedEvent.isOngoing);
        }, 500);
    }, [isEventDataLoaded, searchParams, ongoingEventData, upcomingEventData]);

    const handleResetForm = () => {
        setRegistrationForm({
            fullName: '',
            phoneNumber: '',
            email: '',
            schoolName: '',
            lastEducation: '',
            yearGraduated: 0,
            major: '',
            jobID: 0,
            lastExperience: '',
            eventID: 0
        });

        setPartnershipForm({
            schoolName: '',
            picName: '',
            picPhoneNumber: '',
            picEmail: '',
            address: '',
            eventID: 0
        });
    }

    const handleResetSubmitState = () => {
        setSubmitErrorMessage('');
        setIsSubmitSuccess(false);
        setIsSubmitting(false);
    }

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (isSubmitting) return;
        setSubmitErrorMessage('');

        const registrationPayload = {
            FullName: fullName?.trim(),
            PhoneNumber: phoneNumber?.trim(),
            Email: email?.trim(),
            SchoolName: registrationSchoolName?.trim(),
            LastEducation: lastEducation?.trim(),
            YearGraduated: Number(yearGraduated) || 0,
            Major: major?.trim(),
            JobID: Number(jobID),
            LastExperience: lastExperience?.trim(),
            EventID: Number(registrationForm.eventID) || 0,
        };

        const partnershipPayload = {
            SchoolName: partnershipSchoolName?.trim(),
            PicName: picName?.trim(),
            PicPhoneNumber: picPhoneNumber?.trim(),
            PicEmail: picEmail?.trim(),
            Address: address?.trim(),
        };

        try {
            setIsSubmitting(true);

            const response = formType === 'partnership'
                ? await addData({ url: 'EventPartnerships', reqBody: partnershipPayload })
                : await addData({ url: 'LeadCandidates', reqBody: registrationPayload });

            if (typeof response === 'string') throw new Error(response);

            handleResetForm();
            setIsSubmitSuccess(true);
        } catch (error) {
            setSubmitErrorMessage(error?.message || 'Something went wrong while submitting the form.');

            requestAnimationFrame(() => {
                submitFeedbackRef.current?.scrollIntoView({
                    behavior: 'smooth',
                    block: 'start',
                });
            });
        } finally {
            setIsSubmitting(false);
        }
    };

    const submitErrorAlert = () => (
        <div className="w-full rounded-xl border border-red-200 bg-red-50 px-4 py-3">
            <p className="text-sm text-red-700">{submitErrorMessage}</p>
        </div>
    );

    const submitSuccessContent = () => (
        <div className="w-full h-full flex items-center justify-center">
            <div className="max-w-[320px] flex flex-col items-center justify-center gap-4 text-center py-12">
                <div className="w-16 h-16 rounded-full bg-green-100 flex items-center justify-center">
                    <svg width="36" height="36" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <circle cx="12" cy="12" r="10" stroke="#16A34A" strokeWidth="1.8"/>
                        <path d="M7 12.5L10.5 16L17 9.5" stroke="#16A34A" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                </div>
                <h3 className="text-xl font-semibold text-[#48494B]">Form Submitted</h3>
                <p className="text-sm text-[#48494B]">Your form is submitted successfully. We will inform you in 2–3 working days.</p>
            </div>
        </div>
    );

    const goalCard = ({ data, index }) => {
        return (
            <div
                key={index}
                className="w-[86%] bg-white rounded-3xl shadow-md flex-shrink-0 md:w-[19%]"
                style={{ boxShadow: '0px 0px 6px 2px rgb(0 118 255 / 15%)' }}
            >
                <div className="w-full h-72 overflow-hidden rounded-t-3xl">
                    <img src={data.image} alt={data.name} className="w-full h-full object-cover" />
                </div>
                <div className="flex flex-col gap-2 p-6 h-42 md:h-54 md:p-8">
                    <h3 className="text-[22px] font-bold">{Lang(lang, data.name)}</h3>
                    <p className="text-gray-600 text-sm">{Lang(lang, data.description)}</p>
                </div>
            </div>
        );
    }

    const highlightCard = ({ data, index, backgroundCardSet = 1 }) => {
        let textStyle = { color: '#000000' };
        let backgroundStyle = { backgroundColor: '#FFFFFF' };

        switch (backgroundCardSet) {
            case 2:
                textStyle= { color: '#FFFFFF'};
                backgroundStyle = { backgroundImage: 'linear-gradient(320deg, #FFFFFF 0%, #4497F7 45%, #306DB3 90%)' };
                break;
        }
        return (
            <div key={index} className="flip-container w-[86%] md:w-[19%]" style={{ height: `${highlightCardHeight}px` }}>
                <div className="flip-inner rounded-3xl h-full">
                    <div
                        className="flip-front absolute flex justify-center items-center inset-0 w-full h-full rounded-3xl shadow-md"
                        style={{ ...textStyle, ...backgroundStyle, height: '100%', boxShadow: '0px 0px 6px 2px rgb(0 118 255 / 15%)' }}
                    >
                        <div ref={(element) => { highlightContentRefs.current[index] = element; }} className="flex flex-col gap-4 p-6 md:p-8">
                            <h3 className="text-[28px] font-medium text-center">{data.name}</h3>
                            <div className="w-[80%] flex mx-auto md:w-[80%]">
                                <p className="text-lg text-center md:text-lg" style={ textStyle }>{Lang(lang, data.description)}</p>
                            </div>
                        </div>
                    </div>
                    <div
                        className="flip-back absolute inset-0 w-full h-full bg-white rounded-3xl shadow-md overflow-hidden"
                        style={{ ...textStyle, height: '100%', boxShadow: '0px 0px 6px 2px rgb(0 118 255 / 15%)' }}
                    >
                        <img
                            src={data.image}
                            alt={data.name}
                            className="absolute inset-0 block w-full h-full object-cover object-center scale-110"
                        />
                    </div>
                </div>
            </div> 
        );
    }

    const eventCard = ({ data, index, isOngoing = true }) => {
        const currentEventID = getEventId(data);
        let color = "#34C759";

        switch(data.type) {
            case 'School':
                color = "#B45309";
                break;
            case 'Campus':
                color = "#034694";
                break;
            default:
                break;
        }

        return (
            <div
                key={index}
                ref={(element) => {
                    if (currentEventID) eventRefs.current[currentEventID] = element;
                }}
                className={`rounded-xl md:rounded-[24px] ${isOngoing ? 'bg-green-500' : 'bg-white'} pl-1`}
                style={{ boxShadow: '1px 0px 6px 0px rgb(0 0 0 / 15%)' }}
            >
                <div className="w-full bg-white flex flex-col justify-between items-center gap-4 p-6 rounded-xl md:rounded-[24px] md:flex-row md:gap-0">
                    <div className="w-full flex flex-col items-top gap-5 md:gap-8 md:flex-row">
                        <div className="w-full order-2 flex flex-col justify-center items-center md:w-[10%] md:order-1">
                            <div className="flex flex-row justify-center items-center gap-2 md:flex-col md:gap-0">
                                <p className="text-[24px] text-[#48494B] font-extrabold">
                                    {new Date(data.startDate).toDateString() === new Date(data.endDate).toDateString() 
                                        ? new Date(data.startDate).toLocaleDateString('en-GB', { day: '2-digit' })
                                        : `${new Date(data.startDate).toLocaleDateString('en-GB', { day: '2-digit' })}-${new Date(data.endDate).toLocaleDateString('en-GB', { day: '2-digit' })}`
                                    }
                                </p>
                                <p className="text-[20px] text-[#48494B] uppercase md:text-[14px]">{new Date(data.startDate).toLocaleDateString('en-US', { month: 'short', year: 'numeric' })}</p>
                            </div>
                            <div
                                className="px-3 py-0.5 mt-2 border-2 rounded-full w-max font-medium text-sm"
                                style={{ borderColor: color, color: color }}
                            >
                                {data.type}
                            </div>
                        </div>
                        <div className="w-full order-1 flex justify-center items-center md:w-[10%] md:order-2">
                            <img src={`${baseUrl}/${data.image}`} alt={data.name} className="w-auto h-24 object-contain md:h-20" />
                        </div>
                        <div className="order-3 flex flex-col gap-0 md:gap-2">
                            <p className="text-[16px] text-[#48494B] font-semibold md:font-bold md:text-[18px]">{data.name}</p>
                            <div className="flex flex-row items-top gap-2">
                                <div className="w-4 mt-1">
                                    <svg
                                        width="16"
                                        height="16"
                                        viewBox="0 0 14 14"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                        class="text-slate-500"
                                    >
                                        <path
                                            d="M11.6663 5.83341C11.6663 8.746 8.43526 11.7793 7.35026 12.7162C7.24918 12.7922 7.12614 12.8333 6.99967 12.8333C6.87321 12.8333 6.75017 12.7922 6.64909 12.7162C5.56409 11.7793 2.33301 8.746 2.33301 5.83341C2.33301 4.59574 2.82467 3.40875 3.69984 2.53358C4.57501 1.65841 5.762 1.16675 6.99967 1.16675C8.23735 1.16675 9.42434 1.65841 10.2995 2.53358C11.1747 3.40875 11.6663 4.59574 11.6663 5.83341Z"
                                            stroke="currentColor"
                                            stroke-width="1.16667"
                                            stroke-linecap="round"
                                            stroke-linejoin="round"
                                        />
                                        <path
                                            d="M7 7.58337C7.9665 7.58337 8.75 6.79987 8.75 5.83337C8.75 4.86688 7.9665 4.08337 7 4.08337C6.0335 4.08337 5.25 4.86688 5.25 5.83337C5.25 6.79987 6.0335 7.58337 7 7.58337Z"
                                            stroke="currentColor"
                                            stroke-width="1.16667"
                                            stroke-linecap="round"
                                            stroke-linejoin="round"
                                        />
                                    </svg>
                                </div>
                                <p className="text-[14px] text-[#48494B] mt-0.5">{data.location}</p>
                            </div>
                            <div className="flex flex-row items-top gap-2">
                                <div className="w-4 mt-1">
                                    <svg width="15" height="15" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <g clip-path="url(#clip0)">
                                            <path d="M7.58269 8.16663H5.24935M8.74935 5.83329H5.24935M6.99935 12.8333C10.2211 12.8333 12.8327 10.2217 12.8327 6.99996C12.8327 3.77821 10.2211 1.16663 6.99935 1.16663C3.7776 1.16663 1.16602 3.77821 1.16602 6.99996C1.1642 8.49188 1.73579 9.92744 2.7626 11.0098L1.74935 12.8333H6.99935Z"
                                                stroke="#64748B"
                                                stroke-width="1.17"
                                                stroke-linecap="square"
                                            />
                                        </g>
                                        <defs>
                                            <clipPath id="clip0">
                                            <rect width="14" height="14" fill="white"/>
                                            </clipPath>
                                        </defs>
                                    </svg>
                                </div>
                                <p className="text-[14px] text-[#48494B]">{data.program}</p>
                            </div>
                        </div>
                    </div>
                    <div className="w-full flex flex-col gap-3 md:gap-4 md:w-max">
                        <button onClick={() => openEventRegistration(data, isOngoing)} className="w-full bg-[#E63333] border border-[#E63333] text-white font-medium rounded-full py-2 px-5 text-xs whitespace-nowrap self-center transition-[1s] hover:text-[#E63333] hover:bg-white md:self-end md:w-max">{isOngoing ? "Register Now" : "Pre-Register"}</button>
                        <div className="flex flex-row items-center gap-2 justify-center md:justify-end">
                            <button type="button" onClick={() => openShareModal(data, 'qr')}>
                                <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg" class="text-slate-500">
                                    <path d="M5.25 2.25H3C2.58579 2.25 2.25 2.58579 2.25 3V5.25C2.25 5.66421 2.58579 6 3 6H5.25C5.66421 6 6 5.66421 6 5.25V3C6 2.58579 5.66421 2.25 5.25 2.25Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                    <path d="M15 2.25H12.75C12.3358 2.25 12 2.58579 12 3V5.25C12 5.66421 12.3358 6 12.75 6H15C15.4142 6 15.75 5.66421 15.75 5.25V3C15.75 2.58579 15.4142 2.25 15 2.25Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                    <path d="M5.25 12H3C2.58579 12 2.25 12.3358 2.25 12.75V15C2.25 15.4142 2.58579 15.75 3 15.75H5.25C5.66421 15.75 6 15.4142 6 15V12.75C6 12.3358 5.66421 12 5.25 12Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                    <path d="M15.75 12H13.5C13.1022 12 12.7206 12.158 12.4393 12.4393C12.158 12.7206 12 13.1022 12 13.5V15.75" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                    <path d="M9 5.25V7.5C9 7.89782 8.84196 8.27936 8.56066 8.56066C8.27936 8.84196 7.89782 9 7.5 9H5.25" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                </svg>
                            </button>
                            <a href={data.locationLink} target="_blank" rel="noreferrer noopener">
                                <svg width="18" height="18" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg" class="text-slate-500">
                                    <path d="M11.6663 5.83341C11.6663 8.746 8.43526 11.7793 7.35026 12.7162C7.24918 12.7922 7.12614 12.8333 6.99967 12.8333C6.87321 12.8333 6.75017 12.7922 6.64909 12.7162C5.56409 11.7793 2.33301 8.746 2.33301 5.83341C2.33301 4.59574 2.82467 3.40875 3.69984 2.53358C4.57501 1.65841 5.762 1.16675 6.99967 1.16675C8.23735 1.16675 9.42434 1.65841 10.2995 2.53358C11.1747 3.40875 11.6663 4.59574 11.6663 5.83341Z" stroke="currentColor" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round" />
                                    <path d="M7 7.58337C7.9665 7.58337 8.75 6.79987 8.75 5.83337C8.75 4.86688 7.9665 4.08337 7 4.08337C6.0335 4.08337 5.25 4.86688 5.25 5.83337C5.25 6.79987 6.0335 7.58337 7 7.58337Z" stroke="currentColor" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round" />
                                </svg>
                            </a>
                            <button type="button" onClick={() => openShareModal(data, 'link')}>
                                <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg" class="text-slate-500">
                                    <path d="M13.5 6C14.7426 6 15.75 4.99264 15.75 3.75C15.75 2.50736 14.7426 1.5 13.5 1.5C12.2574 1.5 11.25 2.50736 11.25 3.75C11.25 4.99264 12.2574 6 13.5 6Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                    <path d="M4.5 11.25C5.74264 11.25 6.75 10.2426 6.75 9C6.75 7.75736 5.74264 6.75 4.5 6.75C3.25736 6.75 2.25 7.75736 2.25 9C2.25 10.2426 3.25736 11.25 4.5 11.25Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                    <path d="M13.5 16.5C14.7426 16.5 15.75 15.4926 15.75 14.25C15.75 13.0074 14.7426 12 13.5 12C12.2574 12 11.25 13.0074 11.25 14.25C11.25 15.4926 12.2574 16.5 13.5 16.5Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                    <path d="M6.44238 10.1324L11.5649 13.1174" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                    <path d="M11.5574 4.88245L6.44238 7.86745" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                </svg>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    const partnershipFormContent = () => {
        return (
            <form action="#" className="w-full flex flex-col gap-6 mb-8" onSubmit={handleSubmit}>
                <div ref={submitFeedbackRef} />
                {submitErrorMessage && submitErrorAlert()}
                <Input
                    label="School/University Name"
                    type="text"
                    placeholder="Enter your school or university"
                    helper="* Please enter the name of your school or university."
                    value={partnershipSchoolName}
                    required={true}
                    startIcon={
                        <svg width="20" height="20" viewBox="0 0 20 20" fill="#9CA3AF" xmlns="http://www.w3.org/2000/svg">
                            <path d="M10.0007 17.5L4.16732 14.3333V9.33333L0.833984 7.5L10.0007 2.5L19.1673 7.5V14.1667H17.5007V8.41667L15.834 9.33333V14.3333L10.0007 17.5ZM10.0007 10.5833L15.709 7.5L10.0007 4.41667L4.29232 7.5L10.0007 10.5833ZM10.0007 15.6042L14.1673 13.3542V10.2083L10.0007 12.5L5.83398 10.2083V13.3542L10.0007 15.6042Z"/>
                        </svg>
                    }
                    onChange={(e) => setPartnershipForm({ ...partnershipForm, schoolName: e.target.value })}
                />
                <Input
                    label="PIC Name"
                    type="text"
                    placeholder="Enter PIC name"
                    value={picName}
                    required={true}
                    startIcon={
                        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M15.8327 17.5V15.8333C15.8327 14.9493 15.4815 14.1014 14.8564 13.4763C14.2312 12.8512 13.3834 12.5 12.4993 12.5H7.49935C6.61529 12.5 5.76745 12.8512 5.14233 13.4763C4.5172 14.1014 4.16602 14.9493 4.16602 15.8333V17.5" stroke="#9CA3AF" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round"/>
                            <path d="M9.99935 9.16667C11.8403 9.16667 13.3327 7.67428 13.3327 5.83333C13.3327 3.99238 11.8403 2.5 9.99935 2.5C8.1584 2.5 6.66602 3.99238 6.66602 5.83333C6.66602 7.67428 8.1584 9.16667 9.99935 9.16667Z" stroke="#9CA3AF" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                    }
                    onChange={(e) => setPartnershipForm({ ...partnershipForm, picName: e.target.value })}
                />
                <Input
                    label="Phone Number"
                    type="text"
                    placeholder="8XXXXXXX"
                    helper="* Make sure the phone number is active, registered, and can be contacted."
                    prefix="+62"
                    value={picPhoneNumber}
                    required={true}
                    startIcon={
                        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M18.3332 14.0999V16.5999C18.3341 16.832 18.2866 17.0617 18.1936 17.2744C18.1006 17.487 17.9643 17.6779 17.7933 17.8348C17.6222 17.9917 17.4203 18.1112 17.2005 18.1855C16.9806 18.2599 16.7477 18.2875 16.5165 18.2666C13.9522 17.988 11.489 17.1117 9.32486 15.7083C7.31139 14.4288 5.60431 12.7217 4.32486 10.7083C2.91651 8.53426 2.04007 6.05908 1.76653 3.48325C1.7457 3.25281 1.77309 3.02055 1.84695 2.80148C1.92081 2.58241 2.03945 2.38149 2.19506 2.21011C2.35067 2.03872 2.53969 1.90073 2.75047 1.80498C2.96125 1.70923 3.18951 1.65768 3.4207 1.65325H5.9207C6.32428 1.64929 6.71554 1.78645 7.02624 2.04073C7.33694 2.29501 7.54727 2.64962 7.6207 3.04659C7.7607 3.78992 7.98403 4.51575 8.28737 5.20992C8.39666 5.45949 8.42819 5.73588 8.37795 6.00409C8.3277 6.2723 8.19792 6.51921 8.00403 6.70992L6.9207 7.79325C8.10942 9.89378 9.93917 11.7235 12.0397 12.9123L13.123 11.8289C13.3137 11.635 13.5606 11.5053 13.8288 11.455C14.097 11.4048 14.3734 11.4363 14.623 11.5456C15.3172 11.8489 16.043 12.0723 16.7863 12.2123C17.1833 12.2857 17.5379 12.496 17.7922 12.8067C18.0465 13.1174 18.1836 13.5086 18.1797 13.9123L18.3332 14.0999Z" stroke="#9CA3AF" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                    }
                    onChange={(e) => setPartnershipForm({ ...partnershipForm, picPhoneNumber: e.target.value.replace(/\D/g, '') })}
                />
                <Input
                    label="Email Address"
                    type="email"
                    placeholder="Enter PIC email address"
                    helper="* Make sure the email is active and registered."
                    value={picEmail}
                    required={true}
                    startIcon={
                        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M16.666 3.33325H3.33268C2.41221 3.33325 1.66602 4.07944 1.66602 4.99992V14.9999C1.66602 15.9204 2.41221 16.6666 3.33268 16.6666H16.666C17.5865 16.6666 18.3327 15.9204 18.3327 14.9999V4.99992C18.3327 4.07944 17.5865 3.33325 16.666 3.33325Z" stroke="#9CA3AF" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round"/>
                            <path d="M18.3327 5.83325L10.8577 10.5833C10.6004 10.7444 10.3029 10.8333 9.99935 10.8333C9.69578 10.8333 9.39827 10.7444 9.14099 10.5833L1.66602 5.83325" stroke="#9CA3AF" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                    }
                    onChange={(e) => setPartnershipForm({ ...partnershipForm, picEmail: e.target.value })}
                />
                <Input
                    label="Address"
                    placeholder="Enter school or university address"
                    value={address}
                    startIcon={
                        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M17.5 12.5C17.5 12.942 17.3244 13.366 17.0118 13.6785C16.6993 13.9911 16.2754 14.1667 15.8333 14.1667H5.83333L2.5 17.5V4.16667C2.5 3.72464 2.67559 3.30072 2.98816 2.98816C3.30072 2.67559 3.72464 2.5 4.16667 2.5H15.8333C16.2754 2.5 16.6993 2.67559 17.0118 2.98816C17.3244 3.30072 17.5 3.72464 17.5 4.16667V12.5Z" stroke="#9CA3AF" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                    }
                    onChange={(e) => setPartnershipForm({ ...partnershipForm, address: e.target.value })}
                />
                <button
                    type="submit"
                    disabled={isSubmitting}
                    className="w-full bg-[#E63333] text-white font-medium rounded-full py-2 px-5 text-sm disabled:opacity-60"
                >
                    {isSubmitting ? 'Submitting...' : 'Submit'}
                </button>
            </form>
        );
    }

    const registrationFormContent = () => {
        const jobOptions = jobData.map((item) => ({
            value: item.jobID,
            label: `${item.location} - ${item.jobTitle}`
        }));

        return (
            <form action="#" className="w-full flex flex-col gap-6 mb-8" onSubmit={handleSubmit}>
                <div ref={submitFeedbackRef} />
                {submitErrorMessage && submitErrorAlert()}
                <Input
                    label="Full Name"
                    type="text"
                    placeholder="Enter your full name"
                    value={fullName}
                    required={true}
                    startIcon={
                        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M15.8327 17.5V15.8333C15.8327 14.9493 15.4815 14.1014 14.8564 13.4763C14.2312 12.8512 13.3834 12.5 12.4993 12.5H7.49935C6.61529 12.5 5.76745 12.8512 5.14233 13.4763C4.5172 14.1014 4.16602 14.9493 4.16602 15.8333V17.5" stroke="#9CA3AF" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round"/>
                            <path d="M9.99935 9.16667C11.8403 9.16667 13.3327 7.67428 13.3327 5.83333C13.3327 3.99238 11.8403 2.5 9.99935 2.5C8.1584 2.5 6.66602 3.99238 6.66602 5.83333C6.66602 7.67428 8.1584 9.16667 9.99935 9.16667Z" stroke="#9CA3AF" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                    }
                    onChange={(e) => setRegistrationForm({ ...registrationForm, fullName: e.target.value })}
                />
                <Input
                    label="Phone Number"
                    type="text"
                    placeholder="8XXXXXXX"
                    helper="* Make sure the phone number is active, registered, and can be contacted."
                    prefix="+62"
                    value={phoneNumber}
                    required={true}
                    startIcon={
                        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M18.3332 14.0999V16.5999C18.3341 16.832 18.2866 17.0617 18.1936 17.2744C18.1006 17.487 17.9643 17.6779 17.7933 17.8348C17.6222 17.9917 17.4203 18.1112 17.2005 18.1855C16.9806 18.2599 16.7477 18.2875 16.5165 18.2666C13.9522 17.988 11.489 17.1117 9.32486 15.7083C7.31139 14.4288 5.60431 12.7217 4.32486 10.7083C2.91651 8.53426 2.04007 6.05908 1.76653 3.48325C1.7457 3.25281 1.77309 3.02055 1.84695 2.80148C1.92081 2.58241 2.03945 2.38149 2.19506 2.21011C2.35067 2.03872 2.53969 1.90073 2.75047 1.80498C2.96125 1.70923 3.18951 1.65768 3.4207 1.65325H5.9207C6.32428 1.64929 6.71554 1.78645 7.02624 2.04073C7.33694 2.29501 7.54727 2.64962 7.6207 3.04659C7.7607 3.78992 7.98403 4.51575 8.28737 5.20992C8.39666 5.45949 8.42819 5.73588 8.37795 6.00409C8.3277 6.2723 8.19792 6.51921 8.00403 6.70992L6.9207 7.79325C8.10942 9.89378 9.93917 11.7235 12.0397 12.9123L13.123 11.8289C13.3137 11.635 13.5606 11.5053 13.8288 11.455C14.097 11.4048 14.3734 11.4363 14.623 11.5456C15.3172 11.8489 16.043 12.0723 16.7863 12.2123C17.1833 12.2857 17.5379 12.496 17.7922 12.8067C18.0465 13.1174 18.1836 13.5086 18.1797 13.9123L18.3332 14.0999Z" stroke="#9CA3AF" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                    }
                    onChange={(e) => setRegistrationForm({ ...registrationForm, phoneNumber: e.target.value.replace(/\D/g, '') })}
                />
                <Input
                    label="Email Address"
                    type="email"
                    placeholder="Enter your email address"
                    helper="* Make sure the email is active and registered."
                    value={email}
                    required={true}
                    startIcon={
                        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M16.666 3.33325H3.33268C2.41221 3.33325 1.66602 4.07944 1.66602 4.99992V14.9999C1.66602 15.9204 2.41221 16.6666 3.33268 16.6666H16.666C17.5865 16.6666 18.3327 15.9204 18.3327 14.9999V4.99992C18.3327 4.07944 17.5865 3.33325 16.666 3.33325Z" stroke="#9CA3AF" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round"/>
                            <path d="M18.3327 5.83325L10.8577 10.5833C10.6004 10.7444 10.3029 10.8333 9.99935 10.8333C9.69578 10.8333 9.39827 10.7444 9.14099 10.5833L1.66602 5.83325" stroke="#9CA3AF" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                    }
                    onChange={(e) => setRegistrationForm({ ...registrationForm, email: e.target.value })}
                />
                {formType == 'jobfair' && (
                    <>
                        <Input
                            label="School/University Name"
                            type="text"
                            placeholder="Enter your school or university"
                            helper="* Please enter the name of your school or university."
                            value={registrationSchoolName}
                            required={true}
                            startIcon={
                                <svg width="20" height="20" viewBox="0 0 20 20" fill="#9CA3AF" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M10.0007 17.5L4.16732 14.3333V9.33333L0.833984 7.5L10.0007 2.5L19.1673 7.5V14.1667H17.5007V8.41667L15.834 9.33333V14.3333L10.0007 17.5ZM10.0007 10.5833L15.709 7.5L10.0007 4.41667L4.29232 7.5L10.0007 10.5833ZM10.0007 15.6042L14.1673 13.3542V10.2083L10.0007 12.5L5.83398 10.2083V13.3542L10.0007 15.6042Z"/>
                                </svg>
                            }
                            onChange={(e) => setRegistrationForm({ ...registrationForm, schoolName: e.target.value })}
                        />
                    </>
                )}
                <Input
                    label="Major"
                    type="text"
                    placeholder="Enter your major"
                    value={major}
                    required={true}
                    startIcon={
                        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M15.8327 17.5V15.8333C15.8327 14.9493 15.4815 14.1014 14.8564 13.4763C14.2312 12.8512 13.3834 12.5 12.4993 12.5H7.49935C6.61529 12.5 5.76745 12.8512 5.14233 13.4763C4.5172 14.1014 4.16602 14.9493 4.16602 15.8333V17.5" stroke="#9CA3AF" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round"/>
                            <path d="M9.99935 9.16667C11.8403 9.16667 13.3327 7.67428 13.3327 5.83333C13.3327 3.99238 11.8403 2.5 9.99935 2.5C8.1584 2.5 6.66602 3.99238 6.66602 5.83333C6.66602 7.67428 8.1584 9.16667 9.99935 9.16667Z" stroke="#9CA3AF" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                    }
                    onChange={(e) => setRegistrationForm({ ...registrationForm, major: e.target.value })}
                />
                {formType == 'jobfair' && (
                    <div className="w-full flex flex-row gap-4">
                        <div className="w-full">
                            <Input
                                label="Last Education"
                                placeholder="Enter your last education"
                                value={lastEducation}
                                required={true}
                                startIcon={
                                    <svg width="20" height="20" viewBox="0 0 20 20" fill="#9CA3AF" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M10.0007 17.5L4.16732 14.3333V9.33333L0.833984 7.5L10.0007 2.5L19.1673 7.5V14.1667H17.5007V8.41667L15.834 9.33333V14.3333L10.0007 17.5ZM10.0007 10.5833L15.709 7.5L10.0007 4.41667L4.29232 7.5L10.0007 10.5833ZM10.0007 15.6042L14.1673 13.3542V10.2083L10.0007 12.5L5.83398 10.2083V13.3542L10.0007 15.6042Z"/>
                                    </svg>
                                }
                                onChange={(e) => setRegistrationForm({ ...registrationForm, lastEducation: e.target.value })}
                            />
                        </div>
                        <div className="w-full">
                            <Input
                                label="Year Graduated"
                                placeholder="YYYY"
                                value={yearGraduated === 0 ? '' : yearGraduated}
                                required={true}
                                startIcon={
                                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M3.33333 5.83333C3.33333 4.91286 4.07953 4.16667 5 4.16667H15C15.9205 4.16667 16.6667 4.91286 16.6667 5.83333V15.8333C16.6667 16.7538 15.9205 17.5 15 17.5H5C4.07953 17.5 3.33333 16.7538 3.33333 15.8333V5.83333Z" stroke="#9CA3AF" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round"/>
                                        <path d="M3.33333 9.16667H16.6667" stroke="#9CA3AF" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round"/>
                                        <path d="M6.66667 2.5V5.83333" stroke="#9CA3AF" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round"/>
                                        <path d="M13.3333 2.5V5.83333" stroke="#9CA3AF" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round"/>
                                    </svg>
                                }
                                onChange={(e) => setRegistrationForm({ ...registrationForm, yearGraduated: e.target.value.replace(/\D/g, '').slice(0, 4) })}
                            />
                        </div>
                    </div>
                )}
                <div className="w-full flex flex-col gap-1">
                    <p className="font-medium text-sm md:text-[15px]">Interest Area<span className="text-red-500">*</span></p>
                    <Select
                        value={jobOptions.find((item) => item.value === jobID) || null}
                        onChange={(selectedValue) => setRegistrationForm({ ...registrationForm, jobID: selectedValue?.value || 0 })}
                        options={jobOptions}
                        placeholder="Select your interest area"
                        styles={{
                            control: (base, state) => ({
                                ...base,
                                borderRadius: '9999px',
                                borderColor: state.isFocused ? 'rgb(59 130 246)' : 'rgb(191 219 254)',
                                boxShadow: state.isFocused ? '0 0 0 2px rgba(59,130,246,0.4)' : 'none',
                                '&:hover': {
                                    borderColor: state.isFocused ? 'rgb(59 130 246)' : 'rgb(191 219 254)',
                                },
                                paddingTop: '1px',
                                paddingBottom: '1px',
                                fontSize: '0.875rem',
                            }),
                            menu: (base) => ({
                                ...base,
                                borderRadius: '12px',
                                overflow: 'hidden',
                            }),
                            menuList: (base) => ({
                                ...base,
                                maxHeight: '180px',
                                overflowY: 'auto',
                            }),
                            option: (base, state) => ({
                                ...base,
                                fontSize: '0.875rem',
                                backgroundColor: state.isSelected
                                    ? 'rgb(59 130 246)'
                                    : state.isFocused
                                    ? 'rgb(219 234 254)'
                                    : 'white',
                                color: state.isSelected ? 'white' : 'inherit',
                            }),
                        }}
                    />
                </div>
                {formType == 'jobfair' && (
                    <Input
                        label="Last Experience"
                        placeholder="Enter your last experience"
                        helper="* Leave it blank if you don't have any"
                        value={lastExperience}
                        startIcon={
                            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M7.5 8.33333C9.34095 8.33333 10.8333 6.84095 10.8333 5C10.8333 3.15905 9.34095 1.66667 7.5 1.66667C5.65905 1.66667 4.16667 3.15905 4.16667 5C4.16667 6.84095 5.65905 8.33333 7.5 8.33333Z" stroke="#9CA3AF" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round"/>
                                <path d="M11.5583 11.6667C10.5186 10.5516 8.9866 9.83333 7.29167 9.83333C4.07001 9.83333 1.45834 12.445 1.45834 15.6667C1.45834 16.208 1.75 16.5 2.29167 16.5H9.5" stroke="#9CA3AF" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round"/>
                                <path d="M14.5833 18.3333C14.5833 18.3333 18.3333 14.5833 18.3333 12.0833C18.3333 10.0123 16.6544 8.33333 14.5833 8.33333C12.5123 8.33333 10.8333 10.0123 10.8333 12.0833C10.8333 14.5833 14.5833 18.3333 14.5833 18.3333Z" stroke="#9CA3AF" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round"/>
                                <path d="M14.5833 13.3333C15.2737 13.3333 15.8333 12.7737 15.8333 12.0833C15.8333 11.393 15.2737 10.8333 14.5833 10.8333C13.893 10.8333 13.3333 11.393 13.3333 12.0833C13.3333 12.7737 13.893 13.3333 14.5833 13.3333Z" stroke="#9CA3AF" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round"/>
                            </svg>
                        }
                        onChange={(e) => setRegistrationForm({ ...registrationForm, lastExperience: e.target.value })}
                    />
                )}
                <button
                    type="submit"
                    disabled={isSubmitting}
                    className="w-full bg-[#E63333] border border-[#E63333] text-white font-medium rounded-full py-2 px-5 text-sm transition-[1s] hover:bg-white hover:text-[#E63333] hover:border-[#E63333] disabled:opacity-60"
                >
                    {isSubmitting ? 'Submitting...' : 'Submit'}
                </button>
            </form>
        );
    }

    const eventEmptyState = ({ dataType = 'ongoing' }) => {
        return (
            <div className="w-full flex flex-col items-center justify-center">
                <img src="/asset/raising_star/empty_events.png" className="w-[30%] md:w-[15%]" />
                <h1 className="text-center text-[14px] md:text-[20px] font-bold text-[#48494B]">No {dataType} events at the moment</h1>
                <p className="text-center text-[12px] md:text-[14px] text-[#48494B]">Please stay tuned for upcoming events!</p>
            </div>
        );
    }

    const TestimonialCard = ({ data, variant = 'center', offset = 0 }) => {
        const { opacity, scale } = CARD_VARIANTS[variant];

        const textStyle = "text-[15px] text-[#48494B]"; 
        const nameSize = "text-[16px]";

        return (
            <div
                data-card-inner
                data-offset={offset}
                className="bg-white rounded-[24px] p-8 md:p-10 text-center h-full" 
                style={{
                    opacity,
                    transform: `scale(${scale})`,
                    boxShadow: '0px 0px 6px 2px rgb(0 118 255 / 15%)',
                    transition: 'opacity 0.45s cubic-bezier(0.4,0,0.2,1), transform 0.45s cubic-bezier(0.4,0,0.2,1)',
                }}
            >
                <p className={`${nameSize} font-bold text-[#48494B] mb-3`}>{data.name}</p>
                <p className={`${textStyle} leading-relaxed`}>{data.description}</p>
            </div>
        );
    };

    return (
        <>
            <ModalContent
                isOpen={isShareModalOpen}
                onClose={() => setIsShareModalOpen(false)}
                position={'center'}
                setWidth="92%"
                maxWidth={'560px'}
                setHeight="auto"
                isWarning={false}
                backgroundImage={'white'}
                showCloseButton={false}
            >
                <div className="relative p-4 md:p-6">
                    <button className="md:block absolute top-4 right-4" onClick={() => setIsShareModalOpen(false)}>
                        <img src="/asset/icon/close.svg" alt="close" />
                    </button>

                    <div className="flex flex-col gap-4 pt-1 md:pt-0">
                        <div>
                            <h3 className="text-[#48494B] text-lg md:text-xl font-semibold">{shareModalType === 'qr' ? 'Event QR Code' : 'Share Event'}</h3>
                            <p className="text-[#64748B] text-xs md:text-sm">{shareModalType === 'qr' ? 'Scan this QR to open the same event link.' : 'Share this event link with others.'}</p>
                            {shareModalData.eventName && (
                                <p className="text-[#334155] text-xs md:text-sm my-2">Event: <span className="font-semibold">{shareModalData.eventName}</span></p>
                            )}
                        </div>

                        {shareModalType === 'link' ? (
                            <div className="border border-[#DCEAFE] rounded-xl bg-white p-3 flex flex-col gap-3">
                                <p className="text-[#334155] text-sm font-semibold">Share Link</p>
                                <div className="flex gap-2 items-center">
                                    <input
                                        value={shareModalData.shareUrl}
                                        readOnly
                                        className="w-full border border-[#BFDBFE] rounded-full px-3 py-2 text-xs text-[#334155] bg-[#F8FAFC]"
                                    />
                                    <button
                                        type="button"
                                        onClick={handleCopyShareLink}
                                        className={`rounded-full px-4 py-2 text-xs text-white ${isShareLinkCopied ? 'bg-green-600' : 'bg-[#E63333]'}`}
                                    >
                                        {isShareLinkCopied ? 'Copied' : 'Copy'}
                                    </button>
                                </div>

                                <div className="flex gap-2 items-center">
                                    <a href={shareModalData.emailUrl} target="_blank" rel="noopener noreferrer" className="w-8 h-8 rounded-full bg-[#FDECEC] flex items-center justify-center">
                                        <img className="w-4 h-4" src="/asset/icon/mail_grey.svg" alt="Email" style={{ filter: 'invert(24%) sepia(89%) saturate(2938%) hue-rotate(344deg) brightness(103%) contrast(95%)' }} />
                                    </a>
                                    <a href={shareModalData.whatsappUrl} target="_blank" rel="noopener noreferrer" className="w-8 h-8 rounded-full bg-[#EAF8EE] flex items-center justify-center">
                                        <img className="w-4 h-4" src="/asset/icon/wa_grey.svg" alt="WhatsApp" style={{ filter: 'invert(48%) sepia(88%) saturate(445%) hue-rotate(90deg) brightness(92%) contrast(86%)' }} />
                                    </a>
                                    <a href={shareModalData.facebookUrl} target="_blank" rel="noopener noreferrer" className="w-8 h-8 rounded-full bg-[#EAF1FF] flex items-center justify-center">
                                        <img className="w-[12px] h-[15px]" src="/asset/icon/facebook_grey.svg" alt="Facebook" style={{ filter: 'invert(31%) sepia(79%) saturate(1206%) hue-rotate(200deg) brightness(93%) contrast(95%)' }} />
                                    </a>
                                    <a href={shareModalData.linkedinUrl} target="_blank" rel="noopener noreferrer" className="w-8 h-8 rounded-full bg-[#EAF6FF] flex items-center justify-center">
                                        <img className="w-4 h-4" src="/asset/icon/linkedin_grey.svg" alt="LinkedIn" style={{ filter: 'invert(52%) sepia(72%) saturate(600%) hue-rotate(168deg) brightness(95%) contrast(92%)' }} />
                                    </a>
                                </div>
                            </div>
                        ) : (
                            <div className="border border-[#DCEAFE] rounded-xl bg-white p-3 flex flex-col gap-2">
                                <p className="text-[#334155] text-sm font-semibold">QR Code</p>
                                <div className="flex justify-center">
                                    <img
                                        src={shareModalData.qrImage}
                                        alt="Event QR"
                                        className="w-[220px] h-[220px] border border-[#E2E8F0] rounded-xl bg-white p-1.5"
                                    />
                                </div>
                                <p className="text-[#64748B] text-[11px] text-center">QR contains the same event link.</p>
                            </div>
                        )}

                        {shareModalType === 'link' && (
                            <div className="border border-[#DCEAFE] rounded-xl bg-[#F8FBFF] p-2.5 flex flex-row items-center justify-between">
                                <p className="text-[#64748B] text-xs">Need QR only?</p>
                                <button
                                    type="button"
                                    className="text-[#034694] text-xs font-semibold underline"
                                    onClick={() => setShareModalType('qr')}
                                >
                                    Open QR
                                </button>
                            </div>
                        )}

                        {shareModalType === 'qr' && (
                            <div className="border border-[#DCEAFE] rounded-xl bg-[#F8FBFF] p-2.5 flex flex-row items-center justify-between">
                                <p className="text-[#64748B] text-xs">Need link sharing?</p>
                                <button
                                    type="button"
                                    className="text-[#034694] text-xs font-semibold underline"
                                    onClick={() => setShareModalType('link')}
                                >
                                    Open Link Share
                                </button>
                            </div>
                        )}
                    </div>
                </div>
            </ModalContent>

            <Drawer
                title={isSubmitSuccess ? 'Submission Status' : formTitle}
                description={!isSubmitSuccess ? (
                    <div className="w-full flex flex-col gap-3">
                        {selectedEventName && formType !== 'partnership' && (
                            <div
                                className="bg-white w-full rounded-xl shadow-md px-4 py-3 md:py-4 md:px-6"
                                style={{ boxShadow: '0px 0px 6px 1px rgb(0 118 255 / 10%)' }}
                            >
                                <p className="text-[11px] md:text-sm text-[#64748B]">Event:</p>
                                <p className="text-[12px] md:text-[15px] font-semibold text-[#034694]">{selectedEventName}</p>
                            </div>
                        )}
                        <div
                            className="bg-white w-full flex flex-row items-top gap-2 rounded-xl shadow-md px-4 py-3 md:py-4 md:px-6"
                            style={{ boxShadow: '0px 0px 6px 1px rgb(0 118 255 / 10%)' }}
                        >
                            <div className="scale-[0.8] mb-16 w-[10%] md:scale-[1] md:mb-0">
                                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <rect x="3.33333" y="3.33333" width="13.3333" height="13.3333" rx="1.66667" stroke="#9CA3AF" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round"/>
                                    <path d="M10 6.66667V10.8333" stroke="#9CA3AF" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round"/>
                                    <path d="M10 14.1667H10.0083" stroke="#9CA3AF" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round"/>
                                </svg>
                            </div>
                            <p className='text-[9px] md:text-sm'>{formDescription}</p>
                        </div>
                    </div>
                ) : null}
                isOpen={isOpenDrawer}
                onClose={() => {
                    handleResetForm();
                    handleResetSubmitState();
                    setSelectedEventName('');
                    setIsOpenDrawer(false);
                }}
                position='right'
                setWidth="w-[80%] md:w-[35%]"
                setStyle={{ backgroundImage: 'linear-gradient(125deg, #F1F5F9 45%, #9dc4f2 100%)' }}
            >
                {isSubmitSuccess ? submitSuccessContent() : (formType === 'partnership' ? partnershipFormContent() : registrationFormContent())}
            </Drawer>

            <div className="w-full flex flex-col gap-6 pt-6 md:pt-8 md:gap-14">
                <div className="w-full flex flex-col justify-center items-center gap-4 md:gap-8" data-aos="fade-in">
                <div className="flex flex-row items-end gap-3 md:gap-4">
                    <span className="text-[#034694] text-[42px] font-medium leading-tight text-center md:text-[76px]">Raising</span>
                    <img src="/asset/raising_star/logo.png" className="h-16 mb-3.5 md:h-28 md:mb-6" />
                </div>
                <div className="flex flex-col items-center gap-3">
                    <h1 className="w-[90%] text-[#48494B] text-[25px] font-normal leading-tight text-center tracking-wider md:text-[56px] md:w-full">
                        <b className="text-[#EA2427] font-semibold">S</b>
                        <span>OPRA </span>
                        <b className="text-[#EA2427] font-semibold">T</b>
                        <span>alent </span>
                        <b className="text-[#EA2427] font-semibold">A</b>
                        <span>cceleration </span>
                        <span>& </span>
                        <b className="text-[#EA2427] font-semibold">R</b>
                        <span>eadiness</span>
                    </h1>
                    <p className="text-center text-[16px] w-[90%] md:w-[65%] md:text-[26px]">{Lang(lang, 'raising_title')}</p>
                </div>
            </div>
            
            <div className="flex justify-center items-center">
                <img src="/asset/raising_star/banner_1.png" className="w-[87%] md:w-[70%]" />
            </div>

            <div className="flex flex-col justify-center items-center gap-3 md:gap-6">
                <h2 className="text-[#EA2427] text-[26px] font-semibold md:text-[32px]">{Lang(lang, 'goals')}</h2>
                <div className="w-full flex flex-col justify-center items-center gap-6 md:flex-row md:gap-12">
                    {goalData?.map((data, index) => goalCard({ data, index }))}
                </div>
            </div>

            <div className="flex flex-col justify-center items-center gap-3 md:gap-6">
                <h2 className="text-[#034694] text-[26px] font-semibold md:text-[32px]">Program Highlights</h2>
                <div className="w-full flex flex-col justify-center items-center gap-6 md:flex-row md:gap-12">
                    {highlightData?.map((data, index) => highlightCard({ data, index, backgroundCardSet: ((index + 1) % 2) ? 1 : 2 }))}
                </div>
            </div>

            <div className="flex flex-col justify-center items-center gap-3 md:gap-4 py-8" data-aos="fade-in">
                <h1 className='text-[#034694] text-[26px] font-semibold leading-tight text-center md:text-[60px] md:font-bold'>Build Future Talent With SOPRA</h1>
                <button onClick={() => {
                    setFormType('partnership');
                    setFormTitle('Start Your Journey with SOPRA Early');
                    setFormDescription('This form is intended for schools and universities interested in establishing a strategic collaboration with SOPRA through the Raising STAR program. Our team will review your submission and contact you for further discussion.');
                    handleResetSubmitState();

                    setIsOpenDrawer(true);
                }} className="bg-[#E63333] border-2 border-[#E63333] text-white rounded-full py-1.5 px-3 text-[14px] font-semibold transition-[1s] hover:bg-white hover:text-[#E63333] md:font-medium md:py-3 md:px-6 md:text-[28px]">Start a Partnership with Us!</button>
            </div>

            <div className="overflow-hidden py-4 h-[150px] md:h-[180px]">
                <div className="marquee-track flex flex-row md:gap-8">
                    {[...institutionData, ...institutionData].map((item, index) => {
                        return (
                            <div key={index} className="w-[140px] flex-shrink-0 flex flex-col items-center gap-3 p-3 md:w-[150px]">
                                <div className="w-full h-[70px] flex items-center justify-center md:h-[90px]">
                                    <img src={item.image} className="w-full h-full object-contain" alt={item.name} />
                                </div>
                                <p className="text-[12px] md:text-[13px] font-semibold text-center leading-tight w-full whitespace-normal break-words md:pt-1">{item.name}</p>
                            </div>
                        );
                    })}
                </div>
            </div>

            <div className="w-full flex flex-col gap-6 pt-2 md:pt-0 md:gap-14">
                <div className="w-full flex flex-col justify-center items-center gap-4 md:gap-8" data-aos="fade-in">
                    <h1 className="text-[#48494B] text-[30px] font-normal leading-tight text-center md:text-[76px]">
                        <b className='text-[#EA2427] font-semibold'>Job</b>
                        <span> Fair & </span>
                        <b className="text-[#034694] font-semibold">Career</b>
                        <span> Event </span>
                    </h1>
                    <div className="flex flex-col items-center gap-6">
                        <div className="flex justify-center items-center">
                            <img src="/asset/raising_star/banner_2.png" className="w-[87%] md:w-[70%]" />
                        </div>
                        <p className="text-center text-[14px] w-[90%] md:w-[70%] md:text-[20px]">{Lang(lang, 'job_fair_description')}</p>
                    </div>
                </div>
            </div>

            <div ref={eventSectionRef} className="mx-auto w-full gap-16 flex flex-col py-12 md:py-28" style={{ backgroundImage: 'linear-gradient(160deg, #7BB3F466 5%, #F1F5F9 20%, #7BB3F466 100%)' }} data-aos="fade-in">
                <div className="flex flex-col justify-center items-center gap-8">
                    <h1 className='text-[#48494B] text-[32px] md:text-[84px] w-[80%] md:w-full mx-auto font-normal leading-tight text-center'>
                        <span>Join Our </span>
                        <b className='text-[#034694] font-semibold'>Events</b>
                    </h1>
                    <div className="flex flex-col w-[85%] gap-4 md:w-[60%]">
                        <h2 className="text-[24px]">
                            <b>Ongoing <span className='text-[#034694]'>Events</span></b>
                        </h2>
                        <div className="flex flex-col gap-6">
                            {ongoingEventData.length > 0 ? (
                                ongoingEventData?.map((obj, index) => eventCard({ data: obj, index, isOngoing: true }))
                            ) : (
                                eventEmptyState({ dataType: 'ongoing' })
                            )}
                        </div>
                    </div>
                    <div className="flex flex-col w-[85%] gap-4 md:w-[60%]">
                        <h2 className="text-[24px]">
                            <b>Upcoming <span className='text-[#034694]'>Events</span></b>
                        </h2>
                        <div className="flex flex-col gap-6">
                            {upcomingEventData.length > 0 ? (
                                upcomingEventData?.map((obj, index) => eventCard({ data: obj, index, isOngoing: false }))
                            ) : (
                                eventEmptyState({ dataType: 'upcoming' })
                            )}
                        </div>
                    </div>
                </div>
            </div>

            <div
                className="w-full pt-6 md:pt-4"
                data-aos="fade-in"
            >
                <h1 className="text-[#48494B] text-[30px] font-normal text-center md:text-[64px] md:mb-2">
                    What They <b className="text-[#EA2427] font-semibold">Said</b>
                </h1>

                <div className="w-full overflow-hidden">
                    <div
                        ref={trackRef}
                        className="flex items-center gap-6 md:py-2"
                    >
                        <div className="hidden xl:block flex-shrink-0 w-[82vw] md:w-[640px]">
                            <TestimonialCard data={testimonialData[tIdx(-2)]} variant="far" offset={-2} />
                        </div>
                        <div className="block flex-shrink-0 w-[82vw] md:w-[640px]">
                            <TestimonialCard data={testimonialData[tIdx(-1)]} variant="side" offset={-1} />
                        </div>
                        <div className="flex-shrink-0 w-[82vw] md:w-[640px]">
                            <TestimonialCard data={testimonialData[tIdx(0)]} variant="center" offset={0} />
                        </div>
                        <div className="block flex-shrink-0 w-[82vw] md:w-[640px]">
                            <TestimonialCard data={testimonialData[tIdx(1)]} variant="side" offset={1} />
                        </div>
                        <div className="hidden xl:block flex-shrink-0 w-[82vw] md:w-[640px]">
                            <TestimonialCard data={testimonialData[tIdx(2)]} variant="far" offset={2} />
                        </div>
                    </div>
                </div>

                <div className="flex justify-center gap-4 md:mt-8">
                    <button onClick={() => navigate(-1)} className="w-12 h-12 rounded-full bg-[#EA2427] border border-[#EA2427] stroke-white flex items-center justify-center transition-[1s] hover:stroke-[#EA2427] hover:bg-white">
                        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="current" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                            <polyline points="15 18 9 12 15 6"/>
                        </svg>
                    </button>
                    <button onClick={() => navigate(1)} className="w-12 h-12 rounded-full bg-[#EA2427] border border-[#EA2427] stroke-white flex items-center justify-center transition-[1s] hover:stroke-[#EA2427] hover:bg-white">
                        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="current" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                            <polyline points="9 18 15 12 9 6"/>
                        </svg>
                    </button>
                </div>
            </div>

            <div className="pt-16 pb-24" style={{ backgroundImage: 'linear-gradient(160deg, #7BB3F466 5%, #F1F5F9 20%, #7BB3F466 100%)' }} data-aos="fade-in">
                <p className='text-[#48494B] text-[32px] md:text-[84px] font-normal leading-tight text-center'>{Lang(lang, 'life_at')} <b className='text-[#EA2427] font-semibold'>SOPRA</b> </p>
                <div className='flex flex-row flex-wrap items-center justify-center mt-10 mx-auto gap-4 w-[85%] md:w-[70%]'>
                    {blogData?.map((obj, idx) =>
                        (idx === 0 || idx % 5 === 0) ?
                            <Link key={obj.blogID} to={`/${lang}/blogs/detail?id=${obj.blogID}`} onClick={() => window.scrollTo(0, 0)} className='relative rounded-[20px] md:rounded-[35px] p-5 text-sm font-normal w-full bg-white' style={{ boxShadow: '1px 0px 6px 0px rgb(0 0 0 / 15%)' }}>
                                <div className='h-[200px] md:h-[387px] bg-slate-600 rounded-[20px]'>
                                    <img src={baseUrl + '/' + (obj?.blogThumbnail || obj?.blogImage)} className="w-full h-full object-cover rounded-[20px]" />
                                </div>
                                <div className='flex flex-row items-end justify-between'>
                                    <div className='text-[#48494B] p-2'>
                                        <div className="flex flex-row pt-3">
                                            {obj.blogTags && (obj.blogTags?.split(',').map(tag => tag.trim())).map((val, idx) => (
                                                <div key={idx} className='py-1 px-2 mr-2 rounded-xl md:rounded-full bg-[#E4F0FF]'>
                                                    <p className='text-[11px] md:text-xs'>{val}</p>
                                                </div>
                                            ))}
                                        </div>
                                        <h3 className='pt-2 text-sm md:text-lg font-medium truncate-2-lines'>{lang === 'en' ? obj?.blogTitle_en : obj?.blogTitle_id}</h3>
                                        <div className='h-[43px] w-[95%] overflow-hidden'>
                                            <div className="pt-2 truncate-2-lines" dangerouslySetInnerHTML={{ __html: lang === 'en' ? obj?.blogContent_en : obj?.blogContent_id }} />
                                        </div>
                                    </div>
                                    <img className='w-[35px] md:w-[45px]' src="/asset/arrowNews.png" />
                                </div>
                            </Link>
                            :
                            <Link to={`/${lang}/blogs/detail?id=${obj.blogID}`} onClick={() => window.scrollTo(0, 0)} class='flex flex-row rounded-[20px] md:rounded-[30px] mb-4 text-left text-sm md:text-lg font-normal w-full md:w-[49%] h-[200px] md:h-[263px] bg-white' style={{ boxShadow: '1px 0px 6px 0px rgb(0 0 0 / 15%)' }}>
                                <div class='rounded-s-[20px] md:rounded-s-[30px] bg-slate-600 w-[60%] md:w-[70%] h-full' style={{ backgroundImage: `url('${baseUrl + '/' + (obj?.blogThumbnail || obj?.blogImage)}')`, backgroundSize: 'cover', backgroundRepeat: 'no-repeat' }}></div>
                                <div class='p-2 pr-4 flex flex-col items-end gap-2 justify-between w-full'>
                                    <div class='flex flex-col'>
                                        <div className="px-3 flex flex-row pt-1 pb-2 md:pt-5 gap-2">
                                            {<div className='py-1 px-2 rounded-xl md:rounded-full bg-[#E4F0FF]'>
                                                <p className='text-[11px] md:text-xs'>{obj.blogTags?.split(',').map(tag => tag.trim())[0]}</p>
                                            </div>}
                                            {((obj.blogTags?.split(',').map(tag => tag.trim())).length > 1 &&
                                                <div className='py-1 px-2 rounded-xl md:rounded-full bg-[#E4F0FF]'>
                                                    <p className='text-[11px] md:text-xs'>+{(obj.blogTags?.split(',').map(tag => tag.trim())).length - 1}</p>
                                                </div>)}
                                        </div>
                                        <p className='pl-3 pt-0 md:pt-2 text-[#48494B] font-medium truncate-2-lines'>{lang === 'en' ? obj?.blogTitle_en : obj?.blogTitle_id}</p>
                                        <div className='w-[95%]'>
                                            <div className='pl-3 pt-2 text-xs truncate-2-lines' dangerouslySetInnerHTML={{ __html: lang === 'en' ? obj?.blogContent_en : obj?.blogContent_id }} />
                                        </div>
                                    </div>
                                    <img className='w-[35px] md:w-[45px]' src="/asset/arrowNews.png" />
                                </div>
                            </Link>
                    )}
                </div>
                <div className="flex justify-center">
                    {lengthBlogData > 3 && <Link to={`/${lang}/blogs`} onClick={() => window.scrollTo(0, 0)} className="bg-[#EA2427] text-white rounded-full mt-4 py-1 px-4 cursor-pointer font-semibold">{Lang(lang, 'read_more')}</Link>}
                </div>
            </div>

            <JobDrawer
                isOpen={isDrawerOpen}
                setIsDrawerOpen={setIsDrawerOpen}
                title={drawerTitle}
                job={jobData}
            />
            </div>
        </>
    )
}

export default Raising;